import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'ch-pagination-dropdown',
  templateUrl: './pagination-dropdown.component.html',
  styleUrls: ['./pagination-dropdown.component.css'],
})
export class PaginationDropdownComponent implements OnInit {
  @Output() pageChanged: EventEmitter<any> = new EventEmitter();
  @Input() public totalItems: number;
  @Input() public pageNumber: number;
  @Input() public pageSize: number;
  public _currentPageSize: number;
  public pageSizes: number[] = [10, 20, 50, 100];

  ngOnInit(): void {
    this._currentPageSize = this.pageSize;
  }

  get currentPageSize(): number {
    return this._currentPageSize;
  }

  set currentPageSize(size: number) {
    this._currentPageSize = size;
    this.pageChanged.emit({ pageSize: this._currentPageSize, pageNumber: 1 });
  }

  onPageChanged(pageNum: number): void {
    this.pageChanged.emit({ pageSize: this.currentPageSize, pageNumber: pageNum });
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/pagination-dropdown/pagination-dropdown.component.ts